// extracted by mini-css-extract-plugin
export var label = "_e0-2";
export var slideContainer = "_e0-0";
export var slider = "_e0-1";